export const setIn = (obj, path, value) =>
  typeof path == 'string'
    ? setIn(obj, path.split('.'), value)
    : path.length === 1 && value !== undefined
      ? (obj[path[0]] = value)
      : path.length === 0
        ? obj
        : (obj[path[0]] ||= {}) && setIn(obj[path[0]], path.slice(1), value)

/*
Copied from source of [fast-deep-equal](https://www.npmjs.com/package/fast-deep-equal).

Modified to ignore 'system' key.
*/
export function fastDeepEqual(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    let length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0;)
        if (!fastDeepEqual(a[i], b[i])) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      let key = keys[i];

      if (key !== 'system' && !fastDeepEqual(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  // eslint-disable-next-line
  return a!==a && b!==b;
}

// https://github.com/segunolalive/deepClone/blob/development/deepClone.js
export const deepClone = obj => {
  if (!obj || typeof obj !== "object") {
    return obj;
  }
  let newObj = {};

  if (Array.isArray(obj)) {
    newObj = obj.map(item => deepClone(item));
  } else {
    Object.keys(obj).forEach(key => (newObj[key] = deepClone(obj[key])));
  }
  return newObj;
};
